module.exports = __webpack_public_path__ + "img/home_sp2.png";